import { Box, Typography } from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import React from 'react';
import OrderCancelIcon from '../../../../../svg-icons/OrderCancelIcon';

const OrderCancelled = ({ ticket }) => {
  const order = ticket?.order;
  const orderRef = order?.reference;
  const cancelledBy =
    order?.cancel?.author?.firstName + ' ' + order?.cancel?.author?.lastName;
  const cancelledAt = order?.cancel?.createdAt
    ? format(new Date(order?.cancel?.createdAt), 'dd MMMM yyyy', { locale: fr })
    : '12/12/2012';

  return (
    <Box
      sx={{
        marginTop: '5em',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
        maxWidth: '600px',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <OrderCancelIcon fontSize="large" />
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            Demande d&apos;annulation enregistrée pour la commande {orderRef}
          </Typography>
        </Box>

        {order?.cancel && (
          <>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Le {cancelledAt}
            </Typography>

            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Par {cancelledBy}
            </Typography>

            <Typography variant="body1">
              <strong>Motif :</strong> {order?.cancel?.reason?.name}
            </Typography>

            {!!order?.cancel?.refund?.amountToRefund && (
              <Typography variant="body1">
                <strong>Remboursement :</strong>{' '}
                {`${
                  order?.cancel?.refund?.amountToRefund
                } ${getSymbolFromCurrency(order?.currency?.code)}`}
              </Typography>
            )}

            <Typography variant="body1">
              <strong>Commentaire :</strong> {order?.cancel?.comment || '-'}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default OrderCancelled;
